function apiUrl(path) {
  const normalizedPath = path.startsWith('/') ? path.slice(1) : path;
  return new URL(`api/${normalizedPath}`, new URL('.', window.location.href));
}

export async function api(path, options = {}) {
  const response = await fetch(apiUrl(path), {
    ...options,
    credentials: 'include', // send/receive httpOnly cookie
    headers: { 'Content-Type': 'application/json', ...(options.headers || {}) },
  });
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    // status + body ride along for callers that act on a refusal's payload
    // (a 409 from /timer carries the current timer to adopt).
    throw Object.assign(new Error(data.error || 'Request failed'), {
      status: response.status,
      data,
    });
  }
  // Every API success response carries a JSON body; a 200 whose body fails to
  // parse is a truncated/garbled transfer and must be an error, not `{}` —
  // callers like load() would otherwise overwrite good state with it.
  return response.json().catch(() => {
    throw new Error('Request failed');
  });
}
